import { useCallback } from 'react';
import type { ProgressBarColor } from 'ui';
import type { ProfileFormValues } from '../profile-form';

type ProgressBarValue = { color: ProgressBarColor; threshold: number };

export const useGetFormProgress = () =>
  useCallback(({ values }: { values: Partial<ProfileFormValues> }) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    if (!values || Object.keys(values).length === 0) {
      return { color: 'error', percentage: 0 } as const;
    }

    const entries = Object.entries(values);
    const filledFields = entries.filter(([_, value]) =>
      Array.isArray(value) ? value.length > 0 : Boolean(value),
    ).length;
    const totalFields = entries.length;

    const percentage = Math.round((filledFields / totalFields) * 100);

    const defaultProgressValues: ProgressBarValue[] = [
      { color: 'error', threshold: 0 },
      { color: 'warning', threshold: 30 },
      { color: 'success', threshold: 70 },
    ];

    // eslint-disable-next-line unicorn/prefer-array-find -- TODO
    const color = defaultProgressValues.filter((option) => percentage >= option.threshold).at(-1)?.color;

    return { color, percentage } as const;
  }, []);
